export default "/images/vendor/flag-icon-css/flags/4x3/ye.svg?67bb215c4226cd5a32aae6c7d319634b";